const throttle = (fn, limit) => {
  let inThrottle
  return () => {
    const args = arguments
    if (!inThrottle) {
      fn(args)
      inThrottle = true
      setTimeout(() => inThrottle = false, limit)
    }
  }
}


const debounce = (fn, wait = 500, immediate = false) => {
  let timeout

  return () => {
    const args = arguments
    const later = function () {
      timeout = null
      if (!immediate) fn(args)
    }
    const callNow = immediate && !timeout

    clearTimeout(timeout)
    timeout = setTimeout(later, wait)

    if (callNow) fn(args)
  }
}


const ExcessiveEvents = {
  throttle,
  debounce
}

export default ExcessiveEvents



// WEBPACK FOOTER //
// ./js/utils/ExcessiveEvents.js